import { EOIcon } from '@nx/ui/eo';
import { useI18n } from '@nx/i18n';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { posterLoadRequested, posterUpsertRequested } from '../../store/slices/posterSlice';
export function PosterEditorPage() {
  const { t } = useI18n();
  const { eventId = '' } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const event = useAppSelector((s) => s.events.current);
  const poster = useAppSelector((s) => s.poster.current);
  const [templateId, setTemplateId] = useState('t1');
  const [customTitle, setCustomTitle] = useState('');
  const [deadline, setDeadline] = useState('');

  useEffect(() => {
    dispatch(posterLoadRequested(eventId));
  }, [dispatch, eventId]);

  useEffect(() => {
    if (poster?.templateId) setTemplateId(poster.templateId);
    if (poster?.customTitle) setCustomTitle(poster.customTitle);
  }, [poster]);

  useEffect(() => {
    if (event && !customTitle) setCustomTitle(event.title);
  }, [event, customTitle]);

  const regLink = poster?.registrationLink ?? `${window.location.origin}/register/${eventId}`;

  return (
    <>
      <div className="page-head">
        <div>
          <h2>{t('eo.poster.title')}</h2>
          <p>{t('eo.poster.subtitle')}</p>
        </div>
        <div className="page-head-actions">
          <button type="button" className="btn btn-outline" onClick={() => navigate(`/register/${eventId}`)}>
            <EOIcon n="eye" size={15} />
            {t('eo.poster.previewLanding')}
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              dispatch(
                posterUpsertRequested({
                  eventId,
                  input: {
                    templateId,
                    customTitle,
                    registrationLink: regLink,
                  },
                }),
              );
            }}
          >
            {t('eo.poster.save')}
          </button>
        </div>
      </div>

      <div className="poster-shell">
        <div className="poster-form">
          <p className="eyebrow">{t('eo.poster.templates')}</p>
          <div className="poster-templates">
            {(['t1', 't2', 't3'] as const).map((tpl) => (
              <button
                key={tpl}
                type="button"
                className={`tpl ${tpl} ${templateId === tpl ? 'on' : ''}`}
                onClick={() => setTemplateId(tpl)}
              />
            ))}
          </div>
          <div className="field">
            <label>{t('eo.poster.customTitle')}</label>
            <input className="input" value={customTitle} onChange={(e) => setCustomTitle(e.target.value)} />
          </div>
          <div className="field">
            <label>{t('eo.poster.deadline')}</label>
            <input type="date" className="input" value={deadline} onChange={(e) => setDeadline(e.target.value)} />
          </div>
          <div className="copy-pill" style={{ width: '100%', marginTop: 8 }}>
            <code>{regLink}</code>
          </div>
        </div>

        <div className="poster-preview">
          <div className={`poster-canvas ${templateId}`}>
            <div className="vis">
              <EOIcon n="img" size={32} />
            </div>
            <div className="body">
              <span className="eyb">N-EXCELSIOR</span>
              <h2>{customTitle || event?.title}</h2>
              <p className="when">
                {event?.startDate.toISOString().slice(0, 10)} — {event?.endDate.toISOString().slice(0, 10)}
              </p>
              <div className="foot">
                <div className="qr" />
                <small>{t('eo.poster.scanToRegister')}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
